"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _DeploymentPlayer = _interopRequireDefault(require("../../../DeploymentPlayer"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left8"));
var _certificate = _interopRequireDefault(require("cccisd-icons/certificate"));
var _lock = _interopRequireDefault(require("cccisd-icons/lock4"));
var _play = _interopRequireDefault(require("cccisd-icons/play4"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner11"));
var _spinner2 = _interopRequireDefault(require("cccisd-icons/spinner"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _Overlay = _interopRequireDefault(require("./Overlay"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var langMapper = {
  en: {
    back: 'Back',
    backTo: 'Back To',
    certificate: 'Certificate',
    closed: 'Closed',
    closes: 'Closes',
    comingSoon: 'Coming Soon',
    completeInOrder: 'Completed in order',
    completeInOrderCourse: 'must be completed in order',
    "continue": 'Continue',
    incorrectUrl: 'Incorrect URL',
    module: 'Module',
    opens: 'Opens',
    review: 'Review',
    start: 'Start'
  },
  es: {
    back: 'Regresar',
    backTo: 'Regresar a',
    certificate: 'Certificado',
    closed: 'Cerrado',
    closes: 'Se cierra',
    comingSoon: 'Próximamente',
    completeInOrder: 'Completa en orden',
    completeInOrderCourse: 'se tiene que completar en orden',
    "continue": 'Reanudar',
    incorrectUrl: 'URL incorrecta',
    module: 'Modulo',
    opens: 'Se abre',
    review: 'Repetirse',
    start: 'Empezar'
  }
};
var CurriculumMediator = function CurriculumMediator(props) {
  var history = (0, _cccisdReactRouter.useHistory)();
  var currentDeploymentId = parseInt((0, _cccisdReactRouter.useParams)().currentDeploymentId, 10);
  var actingPawnHash = props.actingPawnHash,
    actingPawnId = props.actingPawnId,
    basePath = props.basePath,
    courseWrapperMediatorProps = props.courseWrapperMediatorProps,
    isPreviewMode = props.isPreviewMode,
    language = props.language,
    onCompleteLocation = props.onCompleteLocation,
    settings = props.settings;
  if (!['es', 'en'].includes(language)) {
    language = 'en';
  }
  var courseTabName = (0, _get2["default"])(settings, 'tabName', null);
  var isCloseModalOnComplete = (0, _get2["default"])(courseWrapperMediatorProps, 'course.navigationSettings.closeModalOnComplete', false);
  var progress = (0, _get2["default"])(props, 'mediatorProps.progress', null);
  var mainProgress = (0, _get2["default"])(props, 'mediatorProps.mainProgress', null);
  if (!progress || !mainProgress) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  function setCurrentDeployment() {
    var deploymentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var additionalPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var isNeedSlash = !!deploymentId && !basePath.endsWith('/');
    history.replace("".concat(basePath).concat(isNeedSlash ? '/' : '').concat(deploymentId ? deploymentId : '').concat(additionalPath));
    if (onCompleteLocation && deploymentId === null && !mainProgress.completed && progress.every(function (deployment) {
      return deployment.assignmentProgress.completed === true;
    })) {
      history.replace(onCompleteLocation);
    }
  }
  function getAssignmentDisplayName(deployment) {
    if (!deployment) {
      deployment = progress.find(function (d) {
        return d.deploymentId === currentDeploymentId;
      });
    }
    var assignmentDisplayName;

    // if repeated deployment, get the parent deploymentId which has the displayName
    var deploymentId = deployment.parentDeploymentId || deployment.deploymentId;
    try {
      assignmentDisplayName = settings.curriculumOptions.find(function (opt) {
        return opt.deploymentId === deploymentId;
      }).displayName || deployment.assignment.label;
    } catch (e) {
      assignmentDisplayName = deployment.assignment.label;
    }
    return assignmentDisplayName;
  }
  function renderDeployment(dep) {
    var _props$courseWrapperM, _props$courseWrapperM2, _props$courseWrapperM3, _props$courseWrapperM4, _props$courseWrapperM5, _props$courseWrapperM6;
    var now = new Date().toISOString();
    var started = (0, _get2["default"])(dep, 'assignmentProgress.started', false);
    var completed = (0, _get2["default"])(dep, 'assignmentProgress.completed', false);
    var closed = !(0, _get2["default"])(dep, 'isOpen', false);
    var opensDate = (0, _get2["default"])(dep, 'opensDate', null);
    var closesDate = (0, _get2["default"])(dep, 'closesDate', null);
    var isAllowed = (0, _get2["default"])(dep, 'isAllowed', false);
    var isCertificate = (0, _get2["default"])(dep, 'assignment.settings.navigation', '').startsWith('courseWrapper') && (0, _get2["default"])(dep, 'assignment.settings.navigationSettings.certificate.toggle', false) && completed;
    var buttonStyle = (_props$courseWrapperM = props.courseWrapperMediatorProps) === null || _props$courseWrapperM === void 0 ? void 0 : (_props$courseWrapperM2 = _props$courseWrapperM.style) === null || _props$courseWrapperM2 === void 0 ? void 0 : _props$courseWrapperM2.buttons;
    var iconStyle = (_props$courseWrapperM3 = props.courseWrapperMediatorProps) === null || _props$courseWrapperM3 === void 0 ? void 0 : (_props$courseWrapperM4 = _props$courseWrapperM3.style) === null || _props$courseWrapperM4 === void 0 ? void 0 : _props$courseWrapperM4.icon;
    var cardStyle = (_props$courseWrapperM5 = props.courseWrapperMediatorProps) === null || _props$courseWrapperM5 === void 0 ? void 0 : (_props$courseWrapperM6 = _props$courseWrapperM5.style) === null || _props$courseWrapperM6 === void 0 ? void 0 : _props$courseWrapperM6.card;
    var btnContentMapper = {
      notStarted: {
        className: 'btn btn-primary',
        style: buttonStyle ? buttonStyle.notStarted : {},
        text: langMapper[language].start,
        icon: /*#__PURE__*/_react["default"].createElement(_play["default"], null)
      },
      inProgress: {
        className: 'btn btn-success',
        style: buttonStyle ? buttonStyle.inProgress : {},
        text: langMapper[language]["continue"],
        icon: /*#__PURE__*/_react["default"].createElement(_play["default"], null)
      },
      completed: {
        className: 'btn btn-info',
        style: buttonStyle ? buttonStyle.completed : {},
        text: langMapper[language].review,
        icon: /*#__PURE__*/_react["default"].createElement(_spinner["default"], null)
      },
      closed: {
        className: 'btn btn-danger',
        style: buttonStyle ? buttonStyle.closed : {},
        text: now < opensDate ? langMapper[language].comingSoon : langMapper[language].closed,
        icon: /*#__PURE__*/_react["default"].createElement(_spinner2["default"], null)
      }
    };
    var btnData = btnContentMapper.notStarted;
    if (closed) {
      btnData = btnContentMapper.closed;
    } else if (completed) {
      btnData = btnContentMapper.completed;
    } else if (started) {
      btnData = btnContentMapper.inProgress;
    }
    var button = /*#__PURE__*/_react["default"].createElement("button", {
      disabled: closed || !isAllowed,
      type: "button",
      className: btnData.className,
      style: btnData.style,
      onClick: function onClick() {
        if (!started) {
          dep.setProgress(true, completed);
        }
        setCurrentDeployment(dep.deploymentId);
      }
    }, isAllowed ? btnData.icon : /*#__PURE__*/_react["default"].createElement(_lock["default"], null), "\xA0\xA0", btnData.text);
    if (!isAllowed) {
      button = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: courseTabName ? "".concat(courseTabName, " ").concat(langMapper[language].completeInOrderCourse) : langMapper[language].completeInOrder
      }, button);
    } else if (closed && (opensDate || closesDate)) {
      button = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: now < opensDate ? "".concat(langMapper[language].opens, " ").concat(opensDate) : "".concat(langMapper[language].closes, " ").concat(closesDate)
      }, button);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12",
      key: dep.deploymentId
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].deploymentCard,
      style: cardStyle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].heading
    }, dep.icon && dep.icon.url && /*#__PURE__*/_react["default"].createElement("span", {
      style: _objectSpread({
        backgroundImage: "url(".concat(dep.icon.url, ")")
      }, iconStyle),
      className: _style["default"].deploymentIcon
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: dep.icon.url,
      alt: dep.icon.name
    })), /*#__PURE__*/_react["default"].createElement("h4", null, getAssignmentDisplayName(dep))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].deploymentDescription
    }, dep.description && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: dep.description
    })), button, isCertificate && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn btn-secondary ' + _style["default"].certificateButton,
      onClick: function onClick() {
        return setCurrentDeployment(dep.deploymentId, '/certificate');
      }
    }, /*#__PURE__*/_react["default"].createElement(_certificate["default"], {
      spaceRight: true
    }), langMapper[language].certificate)));
  }
  if (currentDeploymentId) {
    var _props$courseWrapperM7, _currentDeployment$ic, _currentDeployment$ic2, _currentDeployment$ic3, _currentDeployment$ic4, _props$courseWrapperM8;
    var currentDeployment = progress.find(function (d) {
      return d.deploymentId === currentDeploymentId;
    });
    if (!currentDeployment || !currentDeployment.isAllowed) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-warning"
      }, currentDeployment ? /*#__PURE__*/_react["default"].createElement("p", null, courseTabName ? "".concat(courseTabName, " ").concat(langMapper[language].completeInOrderCourse) : langMapper[language].completeInOrder) : /*#__PURE__*/_react["default"].createElement("p", null, langMapper[language].incorrectUrl), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: 'btn btn-secondary ' + _style["default"].backButton,
        onClick: function onClick() {
          return setCurrentDeployment(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], {
        spaceRight: true
      }), langMapper[language].back));
    }
    return /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
      style: (_props$courseWrapperM7 = props.courseWrapperMediatorProps) === null || _props$courseWrapperM7 === void 0 ? void 0 : _props$courseWrapperM7.overlayStyle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].overlayTop
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].title
    }, (currentDeployment === null || currentDeployment === void 0 ? void 0 : (_currentDeployment$ic = currentDeployment.icon) === null || _currentDeployment$ic === void 0 ? void 0 : _currentDeployment$ic.url) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].icon,
      style: {
        backgroundImage: "url(".concat(currentDeployment === null || currentDeployment === void 0 ? void 0 : (_currentDeployment$ic2 = currentDeployment.icon) === null || _currentDeployment$ic2 === void 0 ? void 0 : _currentDeployment$ic2.url, ")")
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: currentDeployment === null || currentDeployment === void 0 ? void 0 : (_currentDeployment$ic3 = currentDeployment.icon) === null || _currentDeployment$ic3 === void 0 ? void 0 : _currentDeployment$ic3.url,
      alt: getAssignmentDisplayName(),
      className: _style["default"].iconAlly
    })), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: currentDeployment !== null && currentDeployment !== void 0 && (_currentDeployment$ic4 = currentDeployment.icon) !== null && _currentDeployment$ic4 !== void 0 && _currentDeployment$ic4.url ? 6 : 12
      }
    }, getAssignmentDisplayName())), /*#__PURE__*/_react["default"].createElement("button", {
      className: 'btn btn-link ' + _style["default"].back + (((_props$courseWrapperM8 = props.courseWrapperMediatorProps) === null || _props$courseWrapperM8 === void 0 ? void 0 : _props$courseWrapperM8.stickyBackToButton) && ' ' + _style["default"].stickyBackToButton),
      onClick: function onClick() {
        return setCurrentDeployment(null);
      },
      type: "button"
    }, courseTabName ? "".concat(langMapper[language].backTo, " ").concat(courseTabName) : langMapper[language].back)), /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], {
      deploymentId: currentDeploymentId,
      isPreviewMode: isPreviewMode,
      language: language,
      onComplete: function onComplete() {
        currentDeployment.setProgress(true, true);
        if (isCloseModalOnComplete) {
          setCurrentDeployment(null);
        }
      },
      pawnHash: actingPawnHash,
      pawnId: actingPawnId
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, progress.map(renderDeployment));
};
var _default = exports["default"] = CurriculumMediator;